import { render, staticRenderFns } from "./processType.vue?vue&type=template&id=47218f9c&"
import script from "./processType.vue?vue&type=script&lang=js&"
export * from "./processType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports